<sb-card>
  <div card-header>
    <b>{{'lang.deviceDetails.positionsHeadline' | translate}}</b>
  </div>
  <div card-header-more>
  </div>
  <div card-body>
    <sb-device-positions *ngIf="deviceId && permissionService.hasPermission(permissionService.Permission.device_show)"
                         [deviceId]="deviceId"></sb-device-positions>
  </div>
</sb-card>
